// extracted by mini-css-extract-plugin
module.exports = {"textCell":"SummaryRow_textCell__3qee1","firstCell":"SummaryRow_firstCell__3KnvJ"};